"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const config_1 = require("../config");
const Field_1 = require("../Field");
class Input extends Field_1.default {
    constructor(_a) {
        var { placeholder = '', showErrors = config_1.default.inputs.showErrors, onFocus = undefined, onBlur = undefined } = _a, fieldParams = __rest(_a, ["placeholder", "showErrors", "onFocus", "onBlur"]);
        super(fieldParams);
        Object.defineProperty(this, "placeholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showErrors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onFocus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onBlur", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_isFocused", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.placeholder = placeholder;
        this.showErrors = showErrors;
        this.onFocus = onFocus;
        this.onBlur = onBlur;
        this._isFocused = false;
        (0, mobx_1.makeObservable)(this, {
            _isFocused: mobx_1.observable,
            isFocused: mobx_1.computed,
            focus: mobx_1.action,
            write: mobx_1.action,
            blur: mobx_1.action
        });
        this.setUpFocusReaction();
    }
    get isFocused() {
        return this._isFocused;
    }
    focus() {
        this._isFocused = true;
    }
    write(newValue) {
        this.focus();
        this.setValue(newValue);
        if (this.isValid || this.showErrors === 'onWrite')
            this.syncError();
    }
    blur() {
        this._isFocused = false;
        if (this.showErrors === 'onBlur')
            this.syncError();
    }
    setUpFocusReaction() {
        (0, mobx_1.reaction)(() => this.isFocused, (isFocused) => {
            const callback = isFocused ? this.onFocus : this.onBlur;
            callback === null || callback === void 0 ? void 0 : callback(this.parentForm);
        });
    }
    get parentForm() {
        return this._state.parentForm;
    }
}
exports.default = Input;
